import { useLocation } from "react-router-dom";
import { Button } from "@aidron/aidron-ds";

import { CustomText } from "../../StyledComponents/styleComponents.index";

import PropTypes from 'prop-types';

export function FilterButton({ actions, uiState }) {

  const { setShowFilters } = actions || {};

  const { 
    size = "lg",
    icon = "filter",
    showFilters,
    disabled = false,
    appliedFiltersCount
  } = uiState || {};

  const location = useLocation();
  const isSortAdjustmentPage = location.pathname === "/acoes/ajuste-sortimento"; 
  
return (
  <section style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
    <div style={{ position: 'relative' }}>
      <Button
        onClick={() => setShowFilters(!showFilters)}
        icon={icon}
        disabled={disabled}
        type={showFilters ? "filled" : "outlined"}
        size={size}
      />
      {appliedFiltersCount > 0 && (
        <div 
          style={{
            backgroundColor: '#e75d0d',
            blockSize: '20px',
            inlineSize: '20px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            right: 0,
            top: 0,
            marginBlockStart: '-4px',
            marginInlineEnd: '-7px'
          }}>
          <CustomText color="white" weight="bold" textAlign="center">
            {appliedFiltersCount}
          </CustomText>
        </div>
      )}
    </div>

    {isSortAdjustmentPage && (
      <CustomText fontSize={['0.4rem', '0.7rem', '1.1rem']} weight="bold">
        Grupos de Similaridade
      </CustomText>
    )}
  </section>
  );
};

FilterButton.propTypes = { actions: PropTypes.shape(), uiState: PropTypes.shape() };